import { accountConstants } from '../constants';

const initialState = {
    isAccountStructureUpdated: true,

    accountStructure: null,
    accountValues: null,

    fetchingStructure: false,
    fetchingStructureError: null,

    creatingAccount: false,
    creatingAccountError: null,

    creatingSubAccount: false,
    creatingSubAccountError: null,

    updatingAccount: false,
    updatingAccountError: null,

    updatingFormulas: false,
    updatingFormulasError: null,

    deletingAccount: false,
    deletingAccountError: null,

    insertingAccount: false,
    insertingAccountError: null,

    fetchingAccountValues: false,
    fetchingAccountValuesError: null,

    movingAccountUp: false,
    movingAccountUpError: null,

    movingAccountDown: false,
    movingAccountDownError: null,

    movingAccountLeft: false,
    movingAccountLeftError: null,

    movingAccountRight: false,
    movingAccountRightError: null,

    creatingCustomTab: false,
    creatingCustomTabError: null,

    updatingCustomTab: false,
    updatingCustomTabError: null,

    deletingCustomTab: false,
    deletingCustomTabError: null,

    creatingCustomTabAccount: false,
    creatingCustomTabAccountError: null,

    updatingCustomTabAccount: false,
    updatingCustomTabAccountError: null,

    movingCustomTabAccountUp: false,
    movingCustomTabAccountUpError: null,

    movingCustomTabAccountDown: false,
    movingCustomTabAccountDownError: null,

    deletingCustomTabAccount: false,
    deletingCustomTabAccountError: null,

    creatingChangeInAccount: false,
    creatingChangeInAccountError: null,

    creatingSeparator: false,
    creatingSeparatorError: null,

    updatingSeparator: false,
    updatingSeparatorError: null,

    deletingSeparator: false,
    deletingSeparatorError: null,

    movingSeparator: false,
    movingSeparatorError: null,
};

function updateAccountInStructure(accountStructure, updatedAccount) {
    if (!accountStructure || !updatedAccount) {
        return accountStructure;
    }

    const sortByIndex = (accounts) =>
        Array.isArray(accounts)
            ? [...accounts].sort(
                  (a, b) => (a.index ?? 0) - (b.index ?? 0),
              )
            : accounts;

    const isRegularAccountMatch = (row) =>
        updatedAccount.account_id != null &&
        updatedAccount.associated_account_id == null &&
        row.custom_tab_accounts_id == null &&
        row.associated_account_id == null &&
        Number(row.account_id) ===
            Number(updatedAccount.account_id);

        const isAssociatedAccountMatch = (row) =>
            updatedAccount.associated_account_id != null &&
            row.custom_tab_accounts_id == null &&
            Number(row.associated_account_id) ===
                Number(updatedAccount.associated_account_id);

        const isSeparatorMatch = (row) =>
            updatedAccount.separator_id != null &&
            row.separator_id != null &&
            Number(row.separator_id) ===
                Number(updatedAccount.separator_id);

        const patchStandardAccount = (row) => {
            if (!row) {
                return row;
            }

            const isMatch =
                isRegularAccountMatch(row) ||
                isAssociatedAccountMatch(row) ||
                isSeparatorMatch(row);

            const patchedRow = isMatch
                ? {
                    ...row,
                    ...updatedAccount,
                }
                : row;

            if (!Array.isArray(patchedRow.children)) {
                return patchedRow;
            }

            return {
                ...patchedRow,
                children: sortByIndex(
                    patchedRow.children.map(
                        patchStandardAccount,
                    ),
                ),
            };
        };

    const patchStandardArray = (accounts) =>
        Array.isArray(accounts)
            ? sortByIndex(accounts.map(patchStandardAccount))
            : accounts;

    const patchCustomAccount = (customAccount) => {
        if (!customAccount) {
            return customAccount;
        }

        /*
         * A custom-tab account is a wrapper:
         *
         * {
         *     custom_tab_accounts_id,
         *     account_id,
         *     index,
         *     account: { actual regular account }
         * }
         *
         * Do not merge updatedAccount into the wrapper itself.
         */
        const patchedUnderlyingAccount = customAccount.account
            ? patchStandardAccount(customAccount.account)
            : customAccount.account;

        const patchedChildren = Array.isArray(customAccount.children)
            ? sortByIndex(
                  customAccount.children.map(patchCustomAccount),
              )
            : customAccount.children;

        return {
            ...customAccount,
            account: patchedUnderlyingAccount,
            children: patchedChildren,
        };
    };

    return {
        ...accountStructure,

        balancesheet: {
            ...accountStructure.balancesheet,

            assets: patchStandardArray(
                accountStructure.balancesheet?.assets,
            ),

            liabilities: patchStandardArray(
                accountStructure.balancesheet?.liabilities,
            ),

            equities: patchStandardArray(
                accountStructure.balancesheet?.equities,
            ),
        },

        profitloss: patchStandardArray(
            accountStructure.profitloss,
        ),

        cashflow: patchStandardArray(
            accountStructure.cashflow,
        ),

        drivers: patchStandardArray(
            accountStructure.drivers,
        ),

        custom: Array.isArray(accountStructure.custom)
            ? accountStructure.custom.map((tab) => ({
                  ...tab,

                  custom_tab_accounts: Array.isArray(
                      tab.custom_tab_accounts,
                  )
                      ? tab.custom_tab_accounts.map(
                            patchCustomAccount,
                        )
                      : tab.custom_tab_accounts,
              }))
            : accountStructure.custom,
    };
}

        function patchAccountFormulas(account, patch, targetIds) {
            if (!account) return account;

           const matchesAccount =
                patch.associated_account_id != null
                    ? Number(account.associated_account_id) === Number(patch.associated_account_id)
                    : patch.account_id != null &&
                    account.associated_account_id == null &&
                    Number(account.account_id) === Number(patch.account_id);

            const nextChildren = Array.isArray(account.children)
                ? account.children.map((child) => patchAccountFormulas(child, patch, targetIds))
                : account.children;

            if (!matchesAccount) {
                return {
                ...account,
                children: nextChildren,
                };
            }

            return {
                ...account,
                children: nextChildren,
                formulas: Array.isArray(account.formulas)
                ? account.formulas.map((f) =>

                targetIds.has(Number(f.formulas_id))
                            ? { ...f, formula: patch.formula }
                            : f
                    )
                    : account.formulas,
                };
            }

            function patchCustomAccountFormulas(customAccount, patch, targetIds) {
                if (!customAccount) return customAccount;
            return {
                ...customAccount,
                account: customAccount.account
                ? patchAccountFormulas(customAccount.account, patch, targetIds)
                : customAccount.account,
                children: Array.isArray(customAccount.children)
                ? customAccount.children.map((child) =>
                    patchCustomAccountFormulas(child, patch, targetIds)
                    )
                : customAccount.children,
            };
        }

        function patchFormulasEverywhere(accountStructure, formulaMap) {
            if (!accountStructure || !formulaMap || formulaMap.size === 0) {
                return accountStructure;
            }

            return mapAccountsEverywhere(accountStructure, (account) => ({
                ...account,
                formulas: Array.isArray(account.formulas)
                    ? account.formulas.map((f) =>
                        formulaMap.has(Number(f.formulas_id))
                            ? { ...f, formula: formulaMap.get(Number(f.formulas_id)) }
                            : f,
                    )
                    : account.formulas,
            }));
        }

        // Mirrors updateAccountNumberReferences on the server.
        function patchWeightReferencesEverywhere(accountStructure, from, to) {
            if (!accountStructure || from == null || to == null) {
                return accountStructure;
            }

            return mapAccountsEverywhere(accountStructure, (account) => {
                const weight =
                    account.sum_type === 'weightedavgaccount' && account.weight === from
                        ? to
                        : account.weight;
                const bcWeight = account.bc_weight === from ? to : account.bc_weight;

                return weight === account.weight && bcWeight === account.bc_weight
                    ? account
                    : { ...account, weight, bc_weight: bcWeight };
            });
        }

        // Applies `mapAccount` to every account in every section, including
        // the accounts wrapped by custom-tab rows.
        function mapAccountsEverywhere(accountStructure, mapAccount) {
            const patchAccount = (account) => {
                if (!account) return account;

                return {
                    ...mapAccount(account),
                    children: Array.isArray(account.children)
                        ? account.children.map(patchAccount)
                        : account.children,
                };
            };

            const patchCustom = (ca) => {
                if (!ca) return ca;
                return {
                    ...ca,
                    account: ca.account ? patchAccount(ca.account) : ca.account,
                    children: Array.isArray(ca.children)
                        ? ca.children.map(patchCustom)
                        : ca.children,
                };
            };

            const mapSection = (arr) =>
                Array.isArray(arr) ? arr.map(patchAccount) : arr;

            return {
                ...accountStructure,
                profitloss: mapSection(accountStructure.profitloss),
                cashflow: mapSection(accountStructure.cashflow),
                drivers: mapSection(accountStructure.drivers),
                balancesheet: {
                    ...accountStructure.balancesheet,
                    assets: mapSection(accountStructure.balancesheet?.assets),
                    liabilities: mapSection(accountStructure.balancesheet?.liabilities),
                    equities: mapSection(accountStructure.balancesheet?.equities),
                },
                custom: Array.isArray(accountStructure.custom)
                    ? accountStructure.custom.map((tab) => ({
                        ...tab,
                        custom_tab_accounts: Array.isArray(tab.custom_tab_accounts)
                            ? tab.custom_tab_accounts.map(patchCustom)
                            : tab.custom_tab_accounts,
                    }))
                    : accountStructure.custom,
            };
        }

export function accounts(state = initialState, action) {  
    switch (action.type) {
        case accountConstants.GET_ACCOUNT_STRUCTURE_REQUEST: {
            return {
                ...state,
                fetchingStructure: true,
                accountStructure: null,
                fetchingStructureError: null,
            };
        }
        case accountConstants.GET_ACCOUNT_STRUCTURE_SUCCESS: {
            return {
                ...state,
                fetchingStructure: false,
                accountStructure: action.accountStructure,
                fetchingStructureError: null,
            };
        }
        case accountConstants.GET_ACCOUNT_STRUCTURE_FAILURE: {
            return {
                ...state,
                fetchingStructure: false,
                fetchingStructureError: action.error,
            };
        }

        case accountConstants.CREATE_ACCOUNT_REQUEST: {
            return {
                ...state,
                creatingAccount: true,
                creatingAccountError: null,
            };
        }
        case accountConstants.CREATE_ACCOUNT_SUCCESS: {
            return {
                ...state,
                creatingAccount: false,
                accountStructure: action.newAccountStructure,
            };
        }
        case accountConstants.CREATE_ACCOUNT_FAILURE: {
            return {
                ...state,
                creatingAccount: false,
                creatingAccountError: action.error,
            };
        }

        case accountConstants.CREATE_SUB_ACCOUNT_REQUEST: {
            return {
                ...state,
                creatingSubAccount: true,
                creatingSubAccountError: null,
            };
        }
        case accountConstants.CREATE_SUB_ACCOUNT_SUCCESS: {
            const next = action.payload?.accountStructure ?? {};
            const prev = state.accountStructure ?? {};
            return {
                ...state,
                creatingSubAccount: false,
                accountStructure: {
                ...prev,
                ...next,
                currencies: Array.isArray(next.currencies) ? next.currencies : prev.currencies,
                baseCurrencyId: next.baseCurrencyId ?? prev.baseCurrencyId,
                scenarioCurrencyId: next.scenarioCurrencyId ?? prev.scenarioCurrencyId,
                },
            };
        }
        case accountConstants.CREATE_SUB_ACCOUNT_FAILURE: {
            return {
                ...state,
                creatingSubAccount: false,
                creatingSubAccountError: action.error,
            };
        }

        case accountConstants.UPDATE_ACCOUNTS_REQUEST: {
            return {
                ...state,
                updatingAccount: true,
                updatingAccountError: null,
            };
        }
        
        case accountConstants.UPDATE_ACCOUNTS_SUCCESS: {
            const { updatedAccount, updatedFormulas, renumberedAccount } = action.payload;

            let nextStructure = updateAccountInStructure(
                state.accountStructure,
                updatedAccount,
            );

            if (Array.isArray(updatedFormulas) && updatedFormulas.length > 0) {
                const formulaMap = new Map(
                    updatedFormulas.map((f) => [Number(f.formulas_id), f.formula]),
                );
                nextStructure = patchFormulasEverywhere(nextStructure, formulaMap);
            }

            if (renumberedAccount) {
                nextStructure = patchWeightReferencesEverywhere(
                    nextStructure,
                    renumberedAccount.from,
                    renumberedAccount.to,
                );
            }

            return {
                ...state,
                updatingAccount: false,
                accountStructure: nextStructure,
            };
        }
        case accountConstants.UPDATE_ACCOUNTS_FAILURE: {
            return {
                ...state,
                updatingAccount: false,
                updatingAccountError: action.error,
            };
        }

        case accountConstants.UPDATE_FORMULAS_REQUEST: {
            return {
                ...state,
                updatingFormulas: true,
                updatingFormulasError: null,
            };
        }
       case accountConstants.UPDATE_FORMULAS_SUCCESS: {

        const { patch } = action.payload;

            if (!patch?.updated || !state.accountStructure) {
                return { ...state, updatingFormulas: false };
            }
            const targetIds = new Set((patch.formulaIds ?? []).map(Number));
            const mapSection = (arr) =>
                Array.isArray(arr) ? arr.map((a) => patchAccountFormulas(a, patch, targetIds)) : arr;


            return {
                ...state,
                updatingFormulas: false,
                accountStructure: {
                    ...state.accountStructure,
                    profitloss: mapSection(state.accountStructure.profitloss),
                    cashflow: mapSection(state.accountStructure.cashflow),
                    drivers: mapSection(state.accountStructure.drivers),
                    balancesheet: {
                        ...state.accountStructure.balancesheet,
                        assets: mapSection(state.accountStructure.balancesheet?.assets),
                        liabilities: mapSection(state.accountStructure.balancesheet?.liabilities),
                        equities: mapSection(state.accountStructure.balancesheet?.equities),
                    },
                    custom: Array.isArray(state.accountStructure.custom)
                        ? state.accountStructure.custom.map((tab) => ({
                            ...tab,
                            custom_tab_accounts: Array.isArray(tab.custom_tab_accounts)
                                ? tab.custom_tab_accounts.map((ca) =>
                                        patchCustomAccountFormulas(ca, patch, targetIds)
                                    )
                                : tab.custom_tab_accounts,
                        }))
                        : state.accountStructure.custom,
                },
            };
            }
        case accountConstants.UPDATE_FORMULAS_FAILURE: {
            return {
                ...state,
                updatingFormulas: false,
                updatingFormulasError: action.error,
            };
        }

        case accountConstants.DELETE_ACCOUNT_REQUEST: {
            return {
                ...state,
                deletingAccount: true,
                deletingAccountError: null,
            };
        }
        case accountConstants.DELETE_ACCOUNT_SUCCESS: {
            return {
                ...state,
                deletingAccount: false,
                accountStructure: action.accountStructure,
            };
        }
        case accountConstants.DELETE_ACCOUNT_FAILURE: {
            return {
                ...state,
                deletingAccount: false,
                deletingAccountError: action.error,
            };
        }

        case accountConstants.INSERT_ACCOUNT_REQUEST: {
            return {
                ...state,
                insertingAccount: true,
            };
        }
        case accountConstants.INSERT_ACCOUNT_SUCCES: {
            return {
                ...state,
                insertingAccount: false,
                accountStructure: action.accountStructure,
            };
        }
        case accountConstants.INSERT_ACCOUNT_FAILURE: {
            return {
                ...state,
                insertingAccount: false,
                insertingAccountError: action.error,
            };
        }

        case accountConstants.MOVE_ACCOUNT_UP_REQUEST: {
            return {
                ...state,
                movingAccountUp: true,
                movingAccountUpError: null,
            };
        }
        case accountConstants.MOVE_ACCOUNT_UP_SUCCESS: {
            

            const patchedStructure = action.payload.affectedAccounts.reduce(
                (structure, account) =>
                    updateAccountInStructure(structure, account),
                state.accountStructure
            );

            return {
                ...state,
                movingAccountUp: false,
                accountStructure: patchedStructure,
            };
        }
        case accountConstants.MOVE_ACCOUNT_UP_FAILURE: {
            return {
                ...state,
                movingAccountUp: false,
                movingAccountUpError: action.error,
            };
        }

        case accountConstants.MOVE_ACCOUNT_DOWN_REQUEST: {
            return {
                ...state,
                movingAccountDown: true,
                movingAccountDownError: null,
            };
        }
        case accountConstants.MOVE_ACCOUNT_DOWN_SUCCESS: {
            const patchedStructure = action.payload.affectedAccounts.reduce(
                (structure, account) =>
                    updateAccountInStructure(structure, account),
                state.accountStructure
            );

            return {
                ...state,
                movingAccountDown: false,
                accountStructure: patchedStructure,
            };
        }
        case accountConstants.MOVE_ACCOUNT_DOWN_FAILURE: {
            return {
                ...state,
                movingAccountDown: false,
                movingAccountDownError: action.error,
            };
        }

        case accountConstants.MOVE_ACCOUNT_LEFT_REQUEST: {
            return {
                ...state,
                movingAccountLeft: true,
                movingAccountLeftError: null,
            };
        }
        case accountConstants.MOVE_ACCOUNT_LEFT_SUCCESS: {
            
            return {
                ...state,
                movingAccountLeft: false,
                accountStructure: action.accountStructure,
            };
        }
        case accountConstants.MOVE_ACCOUNT_LEFT_FAILURE: {
            return {
                ...state,
                movingAccountLeft: false,
                movingAccountLeftError: action.error,
            };
        }

        case accountConstants.MOVE_ACCOUNT_RIGHT_REQUEST: {
            return {
                ...state,
                movingAccountRight: true,
                movingAccountRightError: null,
            };
        }
        case accountConstants.MOVE_ACCOUNT_RIGHT_SUCCESS: {
            return {
                ...state,
                movingAccountRight: false,
                accountStructure: action.accountStructure,
            };
        }
        case accountConstants.MOVE_ACCOUNT_RIGHT_FAILURE: {
            return {
                ...state,
                movingAccountRight: false,
                movingAccountRightError: action.error,
            };
        }

        case accountConstants.CREATE_CUSTOM_TAB_REQUEST: {
            return {
                ...state,
                creatingCustomTab: true,
            };
        }
        case accountConstants.CREATE_CUSTOM_TAB_SUCCESS: {
            return {
                ...state,
                creatingCustomTab: false,
                accountStructure: action.accountStructure,
            };
        }
        case accountConstants.CREATE_CUSTOM_TAB_FAILURE: {
            return {
                ...state,
                creatingCustomTab: false,
                creatingCustomTabError: action.error,
            };
        }

        case accountConstants.UPDATE_CUSTOM_TAB_REQUEST: {
            return {
                ...state,
                updatingCustomTab: true,
                updatingCustomTabError: null,
            };
        }
        case accountConstants.UPDATE_CUSTOM_TAB_SUCCESS: {
            return {
                ...state,
                updatingCustomTab: false,
                accountStructure: action.accountStructure,
            };
        }
        case accountConstants.UPDATE_CUSTOM_TAB_FAILURE: {
            return {
                ...state,
                updatingCustomTab: false,
                updatingCustomTabError: action.error,
            };
        }

        case accountConstants.DELETE_CUSTOM_TAB_REQUEST: {
            return {
                ...state,
                deletingCustomTab: true,
                deletingCustomTabError: null,
            };
        }
        case accountConstants.DELETE_CUSTOM_TAB_SUCCESS: {
            return {
                ...state,
                deletingCustomTab: false,
                accountStructure: action.accountStructure,
            };
        }
        case accountConstants.DELETE_CUSTOM_TAB_FAILURE: {
            return {
                ...state,
                deletingCustomTab: false,
                deletingCustomTabError: action.error,
            };
        }

        case accountConstants.CREATE_CUSTOM_TAB_ACCOUNT_REQUEST: {
            return {
                ...state,
                creatingCustomTabAccount: true,
            };
        }
        case accountConstants.CREATE_CUSTOM_TAB_ACCOUNT_SUCCESS: {
            return {
                ...state,
                creatingCustomTabAccount: false,
                accountStructure: action.accountStructure,
            };
        }
        case accountConstants.CREATE_CUSTOM_TAB_ACCOUNT_FAILURE: {
            return {
                ...state,
                creatingCustomTabAccount: false,
                creatingCustomTabAccountError: action.error,
            };
        }

        case accountConstants.UPDATE_CUSTOM_TAB_ACCOUNT_REQUEST: {
            return {
                ...state,
                updatingCustomTabAccount: true,
            };
        }
        case accountConstants.UPDATE_CUSTOM_TAB_ACCOUNT_SUCCESS: {
            const newAccountStructure = { ...action.accountStructure };
            return {
                ...state,
                updatingCustomTabAccount: false,
                accountStructure: newAccountStructure,
            };
        }
        case accountConstants.UPDATE_CUSTOM_TAB_ACCOUNT_FAILURE: {
            return {
                ...state,
                updatingCustomTabAccount: false,
                updatingCustomTabAccountError: action.error,
            };
        }

        case accountConstants.MOVE_CUSTOM_TAB_ACCOUNT_UP_REQUEST: {
            return {
                ...state,
                movingCustomTabAccountUp: true,
                movingCustomTabAccountUpError: null,
            };
        }
        case accountConstants.MOVE_CUSTOM_TAB_ACCOUNT_UP_SUCCESS: {
            return {
                ...state,
                movingCustomTabAccountUp: false,
                accountStructure: action.accountStructure,
            };
        }
        case accountConstants.MOVE_CUSTOM_TAB_ACCOUNT_UP_FAILURE: {
            return {
                ...state,
                movingCustomTabAccountUp: false,
                movingCustomTabAccountUpError: action.error,
            };
        }

        case accountConstants.MOVE_CUSTOM_TAB_ACCOUNT_DOWN_REQUEST: {
            return {
                ...state,
                movingCustomTabAccountDown: true,
                movingCustomTabAccountDownError: null,
            };
        }
        case accountConstants.MOVE_CUSTOM_TAB_ACCOUNT_DOWN_SUCCESS: {
            return {
                ...state,
                movingCustomTabAccountDown: false,
                accountStructure: action.accountStructure,
            };
        }
        case accountConstants.MOVE_CUSTOM_TAB_ACCOUNT_DOWN_FAILURE: {
            return {
                ...state,
                movingCustomTabAccountDown: false,
                moveCustomAccountDownFailure: action.error,
            };
        }

        case accountConstants.DELETE_CUSTOM_TAB_ACCOUNT_REQUEST: {
            return {
                ...state,
                deletingCustomTabAccount: true,
                deletingCustomTabAccountError: null,
            };
        }
        case accountConstants.DELETE_CUSTOM_TAB_ACCOUNT_SUCCESS: {
            return {
                ...state,
                deletingCustomTabAccount: false,
                accountStructure: action.accountStructure,
            };
        }
        case accountConstants.DELETE_CUSTOM_TAB_ACCOUNT_FAILURE: {
            return {
                ...state,
                deletingCustomTabAccount: false,
                deletingCustomTabAccountError: action.error,
            };
        }

        case accountConstants.CREATE_CHANGE_IN_ACCOUNT_REQUEST: {
            return {
                ...state,
                creatingChangeInAccount: true,
                creatingChangeInAccountError: null,
            };
        }
        case accountConstants.CREATE_CHANGE_IN_ACCOUNT_SUCCESS: {
            return {
                ...state,
                creatingChangeInAccount: false,
                accountStructure: action.accountStructure,
            };
        }
        case accountConstants.CREATE_CHANGE_IN_ACCOUNT_FAILURE: {
            return {
                ...state,
                creatingChangeInAccount: false,
                creatingChangeInAccountError: action.error,
            };
        }

        case accountConstants.CREATE_SEPARATOR_REQUEST: {
            return {
                ...state,
                creatingSeparator: true,
                creatingSeparatorError: null,
            };
        }

        case accountConstants.CREATE_SEPARATOR_SUCCESS: {
            return {
                ...state,
                creatingSeparator: false,
                creatingSeparatorError: null,
                accountStructure: action.accountStructure,
            };
        }

        case accountConstants.CREATE_SEPARATOR_FAILURE: {
            return {
                ...state,
                creatingSeparator: false,
                creatingSeparatorError: action.error,
            };
        }


        case accountConstants.UPDATE_SEPARATOR_REQUEST: {
            return {
                ...state,
                updatingSeparator: true,
                updatingSeparatorError: null,
            };
        }

        case accountConstants.UPDATE_SEPARATOR_SUCCESS: {
            return {
                ...state,
                updatingSeparator: false,
                updatingSeparatorError: null,
                accountStructure: action.accountStructure,
            };
        }

        case accountConstants.UPDATE_SEPARATOR_FAILURE: {
            return {
                ...state,
                updatingSeparator: false,
                updatingSeparatorError: action.error,
            };
        }

       case accountConstants.DELETE_SEPARATOR_REQUEST: {
            return {
                ...state,
                deletingSeparator: true,
                deletingSeparatorError: null,
            };
        }

        case accountConstants.DELETE_SEPARATOR_SUCCESS: {
            return {
                ...state,
                deletingSeparator: false,
                deletingSeparatorError: null,
                accountStructure: action.accountStructure,
            };
        }

        case accountConstants.DELETE_SEPARATOR_FAILURE: {
            return {
                ...state,
                deletingSeparator: false,
                deletingSeparatorError: action.error,
            };
        }

        case accountConstants.MOVE_SEPARATOR_REQUEST: {
        return {
            ...state,
            movingSeparator: true,
            movingSeparatorError: null,
        };
    }

        case accountConstants.MOVE_SEPARATOR_SUCCESS: {
            return {
                ...state,
                movingSeparator: false,
                movingSeparatorError: null,
                accountStructure: action.accountStructure,
            };
        }

        case accountConstants.MOVE_SEPARATOR_FAILURE: {
            return {
                ...state,
                movingSeparator: false,
                movingSeparatorError: action.error,
            };
        }

        case accountConstants.REORDER_CUSTOM_TABS_REQUEST:
        case accountConstants.REORDER_CUSTOM_TABS_FAILURE:
            return {
                ...state,
                reorderingCustomTabs:
                    action.type === accountConstants.REORDER_CUSTOM_TABS_REQUEST,
                accountStructure: {
                    ...state.accountStructure,
                    custom: action.custom,
                },
                error: action.error,
            };

        case accountConstants.REORDER_CUSTOM_TABS_SUCCESS:
            return {
                ...state,
                reorderingCustomTabs: false,
                accountStructure: action.accountStructure,
            };

        default: {
            return state;
        }
    }
}
